// AuthContext.js
import { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({
    name: localStorage.getItem("name") || null,
    email: localStorage.getItem("email") || null,
  });
  const [token, setToken] = useState(localStorage.getItem("token") || null);

  // Automatically set Axios Authorization header
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common["Authorization"];
    }
  }, [token]);

  // Login function
  const login = async (email, password) => {
    const res = await axios.post("https://jobsinfo.coreaidataedge.com/login", { email, password });
    localStorage.setItem("token", res.data.token);
    localStorage.setItem("name", res.data.name);
    localStorage.setItem("email", res.data.email);
    setToken(res.data.token);
    setUser({ name: res.data.name, email: res.data.email });
  };

  // Register function
  const register = async (name, email, password) => {
    await axios.post("https://jobsinfo.coreaidataedge.com/register", { name, email, password });
  };

  // Logout
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    setToken(null);
    setUser({ name: null, email: null });
  };

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};